import {useCallback, useEffect, useState} from 'react';
import {Box, Button, Grid, makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import CreatorInviteParticipantModal from '../../../../atoms/modals/inviteParticipantModal';
import {
  moveNextPage,
  mutationUpdateUserMetricValue,
  updateUserMetrics
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {createExperience, createUserPreference, updateUserPreference} from '../../../../../store/actions';
import Config from "../../../../../config/config";
import UtilService from '../../../../../helper/service';
import {useHistory, useLocation} from "react-router";
import {updateUserMetricsValue} from '../../../../../store/actions/auth/auth';
import { Loading } from '../../../../atoms/commonLoadings';

const useStyles = makeStyles((theme) => ({
  img: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 215,
    height: 381,
    '@media (max-width: 1400px)': {
      width: 200,
      height: 300,
    },
  },
  btn: {
    width: 144,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  title: {
    color: '#697683',
    fontSize: 23,
    lineHeight: 0.5,
    fontFamily: 'roboto-bold',
  },
  description: {
    color: '#017AEF',
    fontSize: 18,
    marginRight: 5,
    fontFamily: 'roboto-regular',
    '&:hover': {
      cursor: 'pointer',
      color: '#0f9fef'
    }
  },
  info: {
    color: '#212D40',
    fontSize: 18,
    lineHeight: 0.7,
  },
  container: {
    maxWidth: 800,
    margin: 'auto'
  },
  noneInvite: {
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color: '#ED564A'
  },
}));

function LiveExperienceReview() {

  const classes = useStyles();
  const { userMetrics, page, categories } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { is_loading } = useSelector((state: any) => state.experience);
  const { userPreferencesData } = useSelector((state: any) => state.authUser);

  const {
    moderatedName,
    modStartDateTime,
    modEndDateTime,
    asyncParticipants,
    moderatedAgendaSchedules,
    sessionCode,
    moderatedCompleted,
    content,
    item,
    updateBraintrustMetrics,
    startNow,
    measureWay,
    compatible,
    save_setting,
    modLastActivePage,
    selectedHubs,
    using_hub_connectivity
  } = userMetrics;

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const [participantsAddedImg, setParticipantsAddedImg] = useState("/assets/icons/experiencebuilder/participants_added.svg");

  useEffect(() => {
    if (history.location.hash !== '#modgo') {
      UtilService.addHashTag(history, location.pathname, 'modgo');
    }
  }, []);

  const handleModal = () => {
    setModal(!modal);
  };

  const onFinish = async () => {
    if (!moderatedCompleted) {
      const allemails: any = [];
      asyncParticipants.map((item: any) => {
        const tags: any = [];
        if (item.tags) {
          const itemTags = item.tags.split(",");
          if (itemTags && itemTags.length > 0) {
            itemTags.map((t: any) => {
              if (t && t.trim()) {
                tags.push({ tag_name: t.trim() })
              }
            })
          }
        }
        allemails.push({ email: item.email, tags: tags, is_csv: item.is_csv })
      });
      const request = {
        disable_fingerpulse: true,
        title: moderatedName,
        description: '',
        scheduled_start: modStartDateTime,
        scheduled_end: modEndDateTime,
        user_id: loginUserData.user_id,
        status: 'UPCOMING',
        type: 'MODERATED',
        agenda_json: {
          schedules: moderatedAgendaSchedules
        },
        session_code: sessionCode,
        subcategory: item,
        category: content,
        participants: allemails,
        braintrust_id: null,
        braintrust_demo: false,
        hubs: selectedHubs,
        using_hub_connectivity,
        session_origin:userMetrics?.iscopyExperience ? "COPY_EXPERIENCE": null,
      };
      
      dispatch(createExperience(apolloClient.client, request, () => {
        if (updateBraintrustMetrics) {
          dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "BRAINTRUST_USES" }));
          dispatch(updateUserMetrics('updateBraintrustMetrics', false))
        }
        if (measureWay === 1 && compatible !== -1 && save_setting) {
          onSaveSettings();
        }
        dispatch(updateUserMetrics('moderatedCompleted', true));
        dispatch(moveNextPage(page + 1));
        (modLastActivePage < page + 1) && dispatch(updateUserMetrics('modLastActivePage', page + 1));
      }))
    } else {
      dispatch(moveNextPage(page + 1));
      (modLastActivePage < page + 1) && dispatch(updateUserMetrics('modLastActivePage', page + 1));
    }
  };

  const onSaveSettings = () => {
    const req = {
      user_id: Number(loginUserData.user_id),
      metrix_type: 'EXPERIENCE_CREATE_SETTING',
      metrix_value: {
        compatible: compatible,
        save_setting: save_setting
      }
    };
    dispatch(mutationUpdateUserMetricValue(apolloClient.client, req));
    // update user preference data for ASKEVERYTIME
    const pf_id = userPreferencesData.filter((data: any) => data.preference_name === 'ASKEVERYTIME').length ? (userPreferencesData.filter((data: any) => data.preference_name === 'ASKEVERYTIME'))[0].preference_id : "";
    if (pf_id) { // updating
      const req = {
        preference_value: !save_setting,
        preference_id: pf_id,
        preference_information: '',
        user_id: loginUserData.user_id
      };
      dispatch(updateUserPreference(apolloClient.client, req));
    } else { // creating
      const req = {
        preference_information: '',
        preference_value: !save_setting,
        preference_type: '11',
        preference_name: 'ASKEVERYTIME',
        user_id: loginUserData.user_id
      };
      dispatch(createUserPreference(apolloClient.client, req));
    }
  };

  const getExperienceType = useCallback(() => {
    const selectedCategory = categories['moderated'].find((category: any) => category['category'] === content);
    if (selectedCategory) {
      const subCategories = selectedCategory['subcategories'];
      const selectedSubCategory = content !== 'OTHER' && subCategories.find((subcategory: any) => subcategory['subcategory'] === item);
      return `Live Experience > ${selectedCategory['display_category']} > ${content === 'OTHER' ? item : selectedSubCategory['display_subcategory']}`
    }
    return 'Live Experience'
  }, [content, item, categories]);

  return (
    <>
      <p className="creator-title mt-65">

      </p>
      <p className='creator-main-title'>
        Review/Edit and GO LIVE!
      </p>

      <Grid container className={classes.container}>
        <Grid item xs={12} md={8}>
          <div>
            <p className={classes.title}>Experience Name</p>
            <p className={classes.description} onClick={() => dispatch(moveNextPage(2))}>{moderatedName}</p>
          </div>
          <Box mt={5}>
            <p className={classes.title}>Experience Type</p>
            <p className={classes.description} onClick={() => dispatch(moveNextPage(0))}>
              { getExperienceType() }
            </p>
          </Box>
          <Box mt={5}>
            <p className={classes.title}>Date & Time of Event</p>
            <p className={classes.description} onClick={() => dispatch(moveNextPage(2))}>
              {`${startNow ? `Now (${UtilService.getParticipantDateFormatString(modStartDateTime)})` : UtilService.getParticipantDateFormatString(modStartDateTime)} - ${UtilService.getParticipantDateFormatString(modEndDateTime)}`}
            </p>
          </Box>
          <Box mt={5}>
            <p className={classes.title}>Invites</p>
            <p className={classes.info}>Sent through immersion system.</p>
            <p className={classes.info} onClick={() => dispatch(moveNextPage(4))} style={{ marginTop: -12 }}> Event link:&nbsp;
              <span className={classes.description} style={{ lineHeight: 2 }}>
                {Config.DEV_MOD_URL + (loginUserData && loginUserData.invite_link_type === "b" ? '/participant/':'/') + sessionCode}
              </span>
            </p>
          </Box>
          <Box mt={5}>
            <p className={classes.title}>Participants</p>
            <Box display='flex' flexDirection='row' style={{ marginTop: -18 }} >
              {
                asyncParticipants.length > 0 ? (
                  <>
                    <p className={classes.description}
                      onClick={() => dispatch(moveNextPage(4))}
                      style={{ fontWeight: 'bold', fontFamily: 'roboto-black', }}
                      onMouseOver={() => setParticipantsAddedImg("/assets/icons/experiencebuilder/participants_added2.svg")}
                      onMouseOut={() => setParticipantsAddedImg("/assets/icons/experiencebuilder/participants_added.svg")}
                    >
                      {asyncParticipants.length} Participants added
                      </p>
                    <img src={participantsAddedImg} style={{ marginTop: -4 }} alt={'img'} />
                  </>
                ) : (
                  <p className={classes.description} onClick={() => dispatch(moveNextPage(4))}>
                    <span>
                      <span className={classes.noneInvite}>None invited yet.</span> <span style={{ color: '#697683' }}>Send the link above…or</span> go
                        to the previous step to add them.
                      </span>
                  </p>
                )
              }
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box justifyContent="center" display="flex">
            <img src="/assets/icons/experiencebuilder/live-review.svg" alt="avatar" className={classes.img} />
          </Box>
          <Box mt={6} display='flex' justifyContent='center'>
            <Button color='primary' size='large' className={classes.btn} onClick={onFinish} disabled={is_loading ? true : false}>
              {!is_loading ? (!moderatedCompleted ? 'Go Live!' : 'Next') : <Loading />}
            </Button>
          </Box>
        </Grid>

        <CreatorInviteParticipantModal
          open={modal}
          onClose={handleModal}
          data={asyncParticipants}
        />

      </Grid>
      <br />
    </>
  )
}

export default LiveExperienceReview;
